import React from "react";
import PropTypes from "prop-types";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Fade from "@mui/material/Fade";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import PhotoTagSettings from "components/Photos/PhotoTool/Settings/PhotoTagSettings.tsx";

class PhotoSettings extends React.Component {
  constructor(props) {
    super(props);
    this.anchorRef = React.createRef();
  }

  render() {
    const { settingsOpen, setSettingsOpen } = this.props;
    return (
      <>
        <span ref={this.anchorRef} style={{ position: 'absolute', top: 0, right: 0 }} />
        <Popper
          open={settingsOpen}
          anchorEl={this.anchorRef.current}
          placement="bottom-end"
          transition
          style={{ zIndex: 1300 }}
        >
          {({ TransitionProps }) => (
            <ClickAwayListener onClickAway={() => setSettingsOpen(false)}>
              <Fade {...TransitionProps}>
                <Paper className="photo-tool-settings">
                  <PhotoTagSettings />
                </Paper>
              </Fade>
            </ClickAwayListener>
          )}
        </Popper>
      </>
    );
  }
}

PhotoSettings.propTypes = {
  settingsOpen: PropTypes.bool,
  setSettingsOpen: PropTypes.func,
};

export default PhotoSettings;
